const removeFalsy = (obj: { [x: string]: string }): { [x: string]: string } => {
    const output = {};
    Object.keys(obj).forEach((key) => {
        if (obj[key]) output[key] = obj[key];
    });
    return output;
};

export default removeFalsy;
